import { Turbo } from "@hotwired/turbo-rails"

const THRESHOLD = 80
const MAX_PULL = 120

let startY = 0
let currentY = 0
let pulling = false
let indicator = null
let styleInjected = false

function injectStyles() {
  if (styleInjected) return
  styleInjected = true

  const style = document.createElement("style")
  style.textContent = `
    #ptr-indicator {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 0;
      overflow: visible;
      z-index: 99999;
      pointer-events: none;
    }
    #ptr-indicator .ptr-spinner {
      width: 36px;
      height: 36px;
      border: 3px solid rgba(107, 124, 94, 0.2);
      border-top-color: #6B7C5E;
      border-radius: 50%;
      background: white;
      box-shadow: 0 2px 12px rgba(0,0,0,0.15);
      transform: translateY(-50%) scale(0);
      transition: transform 0.2s ease;
    }
    #ptr-indicator .ptr-spinner.visible {
      transform: translateY(0) scale(1);
    }
    #ptr-indicator .ptr-spinner.spinning {
      animation: ptr-spin 0.6s linear infinite;
    }
    @keyframes ptr-spin {
      to { transform: translateY(0) scale(1) rotate(360deg); }
    }
  `
  document.head.appendChild(style)
}

function createIndicator() {
  // Check if indicator still exists in DOM (Turbo might have removed it)
  if (indicator && document.body.contains(indicator)) {
    return indicator
  }

  injectStyles()

  indicator = document.createElement("div")
  indicator.id = "ptr-indicator"
  indicator.innerHTML = `<div class="ptr-spinner"></div>`
  document.body.appendChild(indicator)

  return indicator
}

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}

function onTouchStart(e) {
  if (getScrollTop() > 5) return

  startY = e.touches[0].clientY
  currentY = startY
  pulling = true

  createIndicator()
}

function onTouchMove(e) {
  if (!pulling) return
  if (getScrollTop() > 5) {
    pulling = false
    return
  }

  currentY = e.touches[0].clientY
  const diff = currentY - startY

  if (diff < 0) {
    pulling = false
    return
  }

  const pullDistance = Math.min(diff * 0.5, MAX_PULL)
  const ind = createIndicator()
  const spinner = ind.querySelector(".ptr-spinner")

  // Position the spinner based on pull distance
  ind.style.height = `${pullDistance}px`

  if (pullDistance > 15) {
    spinner.classList.add("visible")
  } else {
    spinner.classList.remove("visible")
  }

  if (pullDistance >= THRESHOLD) {
    spinner.classList.add("spinning")
  } else {
    spinner.classList.remove("spinning")
  }
}

function onTouchEnd() {
  if (!pulling) return
  pulling = false

  const diff = currentY - startY
  const pullDistance = Math.min(diff * 0.5, MAX_PULL)
  const ind = createIndicator()
  const spinner = ind.querySelector(".ptr-spinner")

  if (pullDistance >= THRESHOLD) {
    // Keep spinner visible and spinning during reload
    ind.style.height = "60px"

    Turbo.visit(window.location.href, { action: "replace" })

    // Hide after navigation starts
    setTimeout(() => {
      if (indicator) {
        spinner.classList.remove("visible", "spinning")
        ind.style.height = "0"
      }
    }, 800)
  } else {
    // Animate back
    spinner.classList.remove("visible", "spinning")
    ind.style.height = "0"
  }
}

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    navigator.standalone === true
  )
}

function init() {
  // Enable for testing - remove `!isStandalone()` check temporarily
  if (!isStandalone()) {
    console.log("[PTR] Not in standalone mode, pull-to-refresh disabled")
    return
  }

  console.log("[PTR] Pull-to-refresh enabled")
  document.addEventListener("touchstart", onTouchStart, { passive: true })
  document.addEventListener("touchmove", onTouchMove, { passive: true })
  document.addEventListener("touchend", onTouchEnd, { passive: true })
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
